/**
 * orga-app-api - veranstaltungen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { FunktionsbereichEntfernenMultiRequest } from '../model/funktionsbereichEntfernenMultiRequest';
// @ts-ignore
import { FunktionsbereichFreigebenRequest } from '../model/funktionsbereichFreigebenRequest';
// @ts-ignore
import { FunktionsbereichHinzufuegenMultiRequest } from '../model/funktionsbereichHinzufuegenMultiRequest';
// @ts-ignore
import { FunktionsbereichRequest } from '../model/funktionsbereichRequest';
// @ts-ignore
import { VeranstaltungFunktionsbereichIdentifier } from '../model/veranstaltungFunktionsbereichIdentifier';
// @ts-ignore
import { VeranstaltungIdentifier } from '../model/veranstaltungIdentifier';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class FunktionsbereicheCommandService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * PostFunktionsbereichEntfernen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VerFunktionsbereichNichtGefunden: (VeranstaltungFunktionsbereichNichtGefunden) * VerFunktionsbereichEntfernt: (VeranstaltungFunktionsbereichEntfernt) * VerBenutzerKeinVerLeiterOderTypAdmin: (VeranstaltungBenutzerKeinVeranstaltungsLeiterOderTypAdmin) 
     * @endpoint post /api/ver/command/funktionsbereiche/v1/entfernen
     * @param funktionsbereichRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunktionsbereichEntfernen(funktionsbereichRequest: FunktionsbereichRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VeranstaltungFunktionsbereichIdentifier>;
    public postFunktionsbereichEntfernen(funktionsbereichRequest: FunktionsbereichRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VeranstaltungFunktionsbereichIdentifier>>;
    public postFunktionsbereichEntfernen(funktionsbereichRequest: FunktionsbereichRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VeranstaltungFunktionsbereichIdentifier>>;
    public postFunktionsbereichEntfernen(funktionsbereichRequest: FunktionsbereichRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funktionsbereichRequest === null || funktionsbereichRequest === undefined) {
            throw new Error('Required parameter funktionsbereichRequest was null or undefined when calling postFunktionsbereichEntfernen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/funktionsbereiche/v1/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VeranstaltungFunktionsbereichIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funktionsbereichRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunktionsbereichEntfernenMulti
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VerBenutzerKeinVerLeiterOderTypAdmin: (VeranstaltungBenutzerKeinVeranstaltungsLeiterOderTypAdmin) 
     * @endpoint post /api/ver/command/funktionsbereiche/v1/entfernen/multi
     * @param funktionsbereichEntfernenMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunktionsbereichEntfernenMulti(funktionsbereichEntfernenMultiRequest: FunktionsbereichEntfernenMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VeranstaltungIdentifier>;
    public postFunktionsbereichEntfernenMulti(funktionsbereichEntfernenMultiRequest: FunktionsbereichEntfernenMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VeranstaltungIdentifier>>;
    public postFunktionsbereichEntfernenMulti(funktionsbereichEntfernenMultiRequest: FunktionsbereichEntfernenMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VeranstaltungIdentifier>>;
    public postFunktionsbereichEntfernenMulti(funktionsbereichEntfernenMultiRequest: FunktionsbereichEntfernenMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funktionsbereichEntfernenMultiRequest === null || funktionsbereichEntfernenMultiRequest === undefined) {
            throw new Error('Required parameter funktionsbereichEntfernenMultiRequest was null or undefined when calling postFunktionsbereichEntfernenMulti.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/funktionsbereiche/v1/entfernen/multi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VeranstaltungIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funktionsbereichEntfernenMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunktionsbereichFreigeben
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VerFunktionsbereichNichtGefunden: (VeranstaltungFunktionsbereichNichtGefunden) * VerFunktionsbereichEntfernt: (VeranstaltungFunktionsbereichEntfernt) * VeranstaltungNichtVeroeffentlicht: (VeranstaltungNichtVeroeffentlicht) * VeranstaltungBeendet: (VeranstaltungBeendet) * VeranstaltungGeloescht: (VeranstaltungGeloescht) * VerBenutzerNichtInRolle: (VeranstaltungBenutzerNichtInRolle) * VerBenutzerNichtInFreigeberRolle: (VeranstaltungBenutzerNichtInFreigeberRolle) 
     * @endpoint post /api/ver/command/funktionsbereiche/v1/freigeben
     * @param funktionsbereichFreigebenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunktionsbereichFreigeben(funktionsbereichFreigebenRequest: FunktionsbereichFreigebenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VeranstaltungFunktionsbereichIdentifier>;
    public postFunktionsbereichFreigeben(funktionsbereichFreigebenRequest: FunktionsbereichFreigebenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VeranstaltungFunktionsbereichIdentifier>>;
    public postFunktionsbereichFreigeben(funktionsbereichFreigebenRequest: FunktionsbereichFreigebenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VeranstaltungFunktionsbereichIdentifier>>;
    public postFunktionsbereichFreigeben(funktionsbereichFreigebenRequest: FunktionsbereichFreigebenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funktionsbereichFreigebenRequest === null || funktionsbereichFreigebenRequest === undefined) {
            throw new Error('Required parameter funktionsbereichFreigebenRequest was null or undefined when calling postFunktionsbereichFreigeben.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/funktionsbereiche/v1/freigeben`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VeranstaltungFunktionsbereichIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funktionsbereichFreigebenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunktionsbereichHinzufuegenMulti
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VerBenutzerKeinVerLeiterOderTypAdmin: (VeranstaltungBenutzerKeinVeranstaltungsLeiterOderTypAdmin) 
     * @endpoint post /api/ver/command/funktionsbereiche/v1/hinzufuegen/multi
     * @param funktionsbereichHinzufuegenMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunktionsbereichHinzufuegenMulti(funktionsbereichHinzufuegenMultiRequest: FunktionsbereichHinzufuegenMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VeranstaltungIdentifier>;
    public postFunktionsbereichHinzufuegenMulti(funktionsbereichHinzufuegenMultiRequest: FunktionsbereichHinzufuegenMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VeranstaltungIdentifier>>;
    public postFunktionsbereichHinzufuegenMulti(funktionsbereichHinzufuegenMultiRequest: FunktionsbereichHinzufuegenMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VeranstaltungIdentifier>>;
    public postFunktionsbereichHinzufuegenMulti(funktionsbereichHinzufuegenMultiRequest: FunktionsbereichHinzufuegenMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funktionsbereichHinzufuegenMultiRequest === null || funktionsbereichHinzufuegenMultiRequest === undefined) {
            throw new Error('Required parameter funktionsbereichHinzufuegenMultiRequest was null or undefined when calling postFunktionsbereichHinzufuegenMulti.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/funktionsbereiche/v1/hinzufuegen/multi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VeranstaltungIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funktionsbereichHinzufuegenMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
